import cvFile from '../assets/curriculum-vitae-fabien-bazire.pdf';
import './Footer.scss';

const CvIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="12" x2="12" y2="18" />
    <polyline points="9 15 12 18 15 15" />
  </svg>
);

const Footer = () => (
  <footer className="footer">
    <div className="footer__brand">
      <span className="footer__logo">Fabien Bazire</span>
      <p>Directeur Artistique<br />&amp; UX Designer</p>
    </div>

    <div className="footer__col">
      <p className="footer__col-title">Navigation</p>
      <a href="/#works">Mon Travail</a>
      <a href="/#about">Me Connaître</a>
      <a href="/#approach">Mon Approche</a>
      <a href="/#contact">Contact</a>
    </div>

    <div className="footer__col">
      <p className="footer__col-title">Contact</p>
      <a href="https://www.linkedin.com/in/fabien-bazire/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
      <a href="mailto:bazire.fabien@gmail.com">bazire.fabien@gmail.com</a>
      <a href="tel:+33650393728">+33 6 50 39 37 28</a>
      <a href={cvFile} download="CV-Fabien-Bazire.pdf" className="footer__cv">
        <CvIcon />
        Télécharger mon CV
      </a>
    </div>

    <div className="footer__copy">
      <p>© {new Date().getFullYear()} Fabien Bazire</p>
      <p>Tous droits réservés</p>
    </div>
  </footer>
);

export default Footer;
